import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "desktop-preview-3BrKi",
  "use": "desktop-preview-3BrKi-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"desktop-preview-3BrKi\"><path d=\"M2 11h16V2H2v9zM0 0h20v13H0V0zm9 13h2v3H9v-3zm-4 3h10v2H5v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol